// This util created to get access to global "google" variable with potentially optional typing.
// Do not use "google" directly in your code.
// Use "getGoogle()" and handle potential undefined cases.
// This util helpts to avoid "google is not defined" bugs
export const getGoogle = () => window.google as typeof google | undefined;
